// Pasif Cari Hesaplar penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.passive';

export const accountsPassiveGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Pasif cariler nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Pasif cari hesap silinmez; yalnız günlük cari listesinde gösterilmez. Böylece geçmiş kayıtlar korunur, çalışma ekranı sade kalır.'),
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Pasif cari nedir?'),
      text: t(`${G}.s1.text`, 'Bir cari pasife alındığında kaydı silinmez, yalnız aktif listeden ayrılır. Geçmiş hareketleri, raporları ve ilgili kayıtları denetim ve raporlama için erişilebilir kalır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Artık çalışılmayan müşteri / tedarikçi hesaplarını aktif listeden kaldırmak için.'),
        t(`${G}.s1.tip2`, 'Yanlışlıkla yeni işlem açılmasını önlemek için.'),
        t(`${G}.s1.tip3`, 'Geçmiş verileri koruyup ekranı daha okunur yapmak için.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Listeyi inceleyin'),
      text: t(`${G}.s2.text`, 'Bu listede yalnız pasif durumdaki cariler, ada göre sıralı olarak görünür: unvan, yetkili kişi ve cep telefonu.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Cariyi tekrar aktif yapın'),
      text: t(`${G}.s3.text`, 'Satırın sonundaki "Aktif Yap" simgesine basın. Hesap yeniden aktif olur ve ana cari listesinde tekrar görünür.'),
    },
    {
      region: 'pagination',
      title: t(`${G}.s4.title`, '4. Sayfalar arasında gezin'),
      text: t(`${G}.s4.text`, '10\'dan fazla pasif cari varsa liste sayfalara bölünür; sayfa başına 5, 10 veya 25 satır seçebilirsiniz.'),
    },
  ],
});
